import HeaderBar from "../../common/HeaderBar";
import SideBar from "../../common/SideBar";
import ReasoningBody from "./ReasoningBody";

const ReasoningPage = () => {
  return (
    <main className="ff2 main-page">
      <HeaderBar />
      <div className="overflow-hidden inner-page-content inner-page-content--aira-chat">
        <SideBar />
        <ReasoningBody />
      </div>
    </main>
  );
};

export default ReasoningPage;
